import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import { Button, Row, Col, Dropdown } from "react-bootstrap";
import Workbook from "react-excel-workbook";
import { Heading5, Heading6, Icon, ToggleSwitch } from "../widgets";
import { SubNav } from "../layout/submenu";
import { isPlannedOrTodate, isToday } from "../../helpers/common";
import { DISPLAY_DATE_FORMAT2 } from "../../constants";
import {
  getUserConfiguration,
  userConfiguration,
  updateConfiguration,
} from "../../actions/user";
import { getFarmEntityInfo } from "../../actions/farm";
import { useLoadHistoryContext } from "./context/LoadHistoryContext";
import { Unit } from "../../helpers/unit";

const LoadHistoryHeader = (props) => {
  const userFarmConfig = useSelector((state) => state.user.farmConfiguration);
  const farmName = useSelector((state) => state.farm.currentFarm.farm_name);
  const equipmentGroupList = useSelector(
    (state) => state.equipmentGroup.equipmentGroupList
  );
  const farmEntityInfo = useSelector((state) => state.farm.farmEntityInfo);
  const loadHistory = useSelector((state) => state.equipmentGroup.loadHistory);
  const loadHistoryHeaders = useSelector(
    (state) => state.equipmentGroup.loadHistroyHeader
  );
  const {
    rangeId,
    range,
    custom: { from, to },
  } = useSelector((state) => state.analyze.searchParams);
  const autoRefresh = useSelector((state) =>
    state.user.configuration.autoRefresh &&
      state.user.configuration.autoRefresh.hasOwnProperty("load_history")
      ? state.user.configuration.autoRefresh.load_history
      : false
  );

  const dispatch = useDispatch();
  const unit = Unit.getInstance();

  const {
    farmId,
    crewId,
    egId,
    loadList,
    loads,
    getSearchHistory,
    getPickedListTable,
    getKpiData,
    titleName,
    closeButton,
    backButton,
    getDeletedSearchHistory,
    selectedViewType,
    setSelectedViewType,
    getTareHistory,
  } = props;
  const {
    showDeletedLoads,
    setShowDeletedLoads,
    enableBulkEdit,
  } = useLoadHistoryContext();
  const [title, setTitle] = useState("");
  let timerId = null;

  const userPreferredData = useMemo(() => {
    const payload =
      userFarmConfig && userFarmConfig.payload ? userFarmConfig.payload : null;
    const remember = payload && payload.remember ? payload.remember : null;
    const loadHistroy =
      remember && remember.load_histroy ? remember.load_histroy : null;
    const data = {
      selected_columns:
        loadHistroy && loadHistroy.selected_columns
          ? loadHistroy.selected_columns
          : [],
      column_order:
        loadHistroy && loadHistroy.column_order ? loadHistroy.column_order : [],
    };
    return data;
  }, [userFarmConfig]);

  useEffect(() => {
    let subTitle = null;
    if (egId) {
      const filteredList = equipmentGroupList.filter(
        (item) => item.equipment_group_uuid === egId
      );
      subTitle =
        filteredList.length > 0 ? filteredList[0].equipment_group_name : "";
    } else if (crewId) {
      subTitle = (farmEntityInfo || {}).name || "";
    } else subTitle = farmName ? farmName : "";
    setTitle(subTitle ? subTitle : titleName);
  }, [farmId, crewId, egId, titleName, equipmentGroupList, farmEntityInfo]);

  const findHeader = (headerName, Headers) => {
    let initialHeaders = loads["loadHistory"].header;
    const findHeader = Headers.find(
      (item) => item.key === headerName && item.isExport
    );
    if (headerName === "load_seconds") {
      const tmpHead = initialHeaders.find(
        (item) => item.key === "actual_duration" && item.isExport
      );
      return tmpHead || findHeader;
    } else if (headerName === "load_date") {
      const tmpHead = initialHeaders.find(
        (item) => item.key === "load_time" && item.isExport
      );
      return tmpHead || findHeader;
    } else {
      return findHeader;
    }
  };

  const addLoadHistoryHeader = (header, type) => {
    // if (geo_custom_params && geo_custom_params.length > 0 && type === "loadHistory") {
    //     geo_custom_params.forEach(it => {
    //         if (it.visible && it.key !== "id") {
    //             header.push({
    //                 key: it.key.toLowerCase(),
    //                 filter: null,
    //                 label: it.label,
    //                 isShow: it.visible
    //             });
    //         }
    //     });
    // }
    return header.map((item, index) => (
      <Workbook.Column key={index} value={item.key} label={item.label} />
    ));
  };

  const getWorkSheets = (from) => {
    return Object.keys(loads).map((type) => {
      let { title, header, body } = loads[type];
      const isLoadHistory = type === "loadHistory";
      const istareHistory = type === "tareLoads";
      let updatedBody;
      if (isLoadHistory) {
        updatedBody = body.map((it) => {
          const {
            field_geo_shape_properties: fieldGeoParams = {},
            rate_info = {},
            ...props
          } = it;
          const { rate_value, rate_type_name, own_bed_rate_value, additional_surcharge_percent, surcharge_value, surcharge_type_name, total } = rate_info;
          let rateInfoCombined = `Rate: ${rate_value ? `$${rate_value} (${rate_type_name})` : '0'} | Surcharge: ${surcharge_value ? `$${surcharge_value} (${surcharge_type_name})` : '0'} | Own Bed: ${own_bed_rate_value ? `$${own_bed_rate_value}` : '0'} | Additional Surcharge: ${additional_surcharge_percent ? `${additional_surcharge_percent} %` : '0'} | Total: ${total ? `$${unit.toFixedOf(total, 2)}` : '0'}`;
          return {
            ...props,
            ...fieldGeoParams,
            rate_info: rate_value ? rateInfoCombined : '',
          };
        });
        const { selected_columns } = userPreferredData;
        header = header.filter((item) => item.isExport);
        let headerData = [];

        if (
          from === "all" &&
          loadHistoryHeaders &&
          loadHistoryHeaders.length > 0
        ) {
          const tmpHeaderAll = [];
          loadHistoryHeaders.forEach((name) => {
            let head = findHeader(name, header);
            if (head) {
              tmpHeaderAll.push(head);
            }
          });
          const tmpHeader1 = header.filter(
            (item) => item.isExport && !loadHistoryHeaders.includes(item.key)
          );
          headerData = [...tmpHeaderAll, ...tmpHeader1];
        } else if (from === "visible") {
          let tmpHeader = [];
          if (
            selected_columns &&
            selected_columns.length > 0 &&
            loadHistoryHeaders.length === 0
          ) {
            selected_columns.forEach((name) => {
              let head = findHeader(name, header);
              if (head) {
                tmpHeader.push(head);
              }
            });
          } else if (
            selected_columns &&
            selected_columns.length > 0 &&
            loadHistoryHeaders &&
            loadHistoryHeaders.length > 0
          ) {
            loadHistoryHeaders.forEach((name) => {
              let head = findHeader(name, header);
              if (head && selected_columns.includes(name)) {
                tmpHeader.push(head);
              }
            });

            const excludedColumn = [];
            selected_columns.forEach((name) => {
              let head = findHeader(name, header);
              if (head && !loadHistoryHeaders.includes(name)) {
                excludedColumn.push(head);
              }
            });
            tmpHeader = [...tmpHeader, ...excludedColumn];
          }
          headerData = tmpHeader;
        }
        header = headerData && headerData.length > 0 ? headerData : header;
      }
      let updateTaredBody;
      if (istareHistory) {
        updateTaredBody = body.map((e) => {
          return {
            ...e,
            load_gross_weight: unit.toRoundOfWeight(e.load_gross_weight, false),
            load_capacity: unit.toRoundOfWeight(e.load_capacity, false),
            light_weight: unit.toRoundOfWeight(e.light_weight, false),
          };
        });
      }
      let downloadData = isLoadHistory
      ? [...updatedBody]
      : istareHistory
      ? [...updateTaredBody]
      : [...body];
      if (downloadData && downloadData.length > 0) {
        downloadData.forEach((obj) => {
          Object.keys(obj).forEach((key) => {
            if (Array.isArray(obj[key])) {
              obj[key] = obj[key].toString();
            }
          });
        });
      }

      return (
        <Workbook.Sheet key={type} data={downloadData} name={title}>
          {addLoadHistoryHeader(header, type)}
        </Workbook.Sheet>
      );
    });
  };

  const getExcelFileName = () => {
    let dateRange = null;

    if (isPlannedOrTodate(range)) {
      let history =
        loadHistory && loadHistory.history ? loadHistory.history : [];

      if (history.length > 0) {
        history = history.sort((a, b) => {
          const dateA = new Date(a.load_date);
          const dateB = new Date(b.load_date);

          if (dateA < dateB) return -1;
          else if (dateA > dateB) return 1;
          else return 0;
        });

        dateRange = `${moment
          .utc(history[0].load_date)
          .format(DISPLAY_DATE_FORMAT2)} to ${moment
            .utc(history[history.length - 1].load_date)
            .format(DISPLAY_DATE_FORMAT2)}`;
      }
    } else if (
      moment.utc(from).format(DISPLAY_DATE_FORMAT2) ===
      moment.utc(to).format(DISPLAY_DATE_FORMAT2)
    )
      dateRange = `${moment.utc(from).format(DISPLAY_DATE_FORMAT2)}`;
    else
      dateRange = `${moment
        .utc(from)
        .format(DISPLAY_DATE_FORMAT2)} to ${moment
          .utc(to)
          .format(DISPLAY_DATE_FORMAT2)}`;

    return `LoadHistory_${farmName.replace(/(\W+)/gi, "_")}${dateRange ? `_${dateRange}` : ""
      }.xlsx`;
  };

  const fileName = getExcelFileName();

  useEffect(() => {
    dispatch(
      getUserConfiguration("autoRefresh", { configuration_name: "AutoRefresh" })
    );
  }, []);

  useEffect(() => {
    if (crewId) dispatch(getFarmEntityInfo({ entity_uuid: crewId }));
  }, [crewId]);

  useEffect(() => {
    clearTimer();
    if (autoRefresh && isToday(range))
      timerId = setInterval(() => handleRefresh(), 5 * 60 * 1000);

    return clearTimer;
  }, [autoRefresh, rangeId]);

  const clearTimer = () => {
    if (timerId) clearInterval(timerId);
    timerId = null;
  };

  const handleRefreshToggle = (e) => {
    const isChecked = e.target.checked;
    const cb = (isSaved) =>
      !isSaved &&
      dispatch(userConfiguration("autoRefresh", { load_history: isChecked }));

    dispatch(userConfiguration("autoRefresh", { load_history: isChecked }));

    dispatch(
      updateConfiguration(
        {
          configuration_name: "AutoRefresh",
          configuration: { load_history: isChecked },
        },
        cb
      )
    );
    if (isChecked) handleRefresh();
  };

  const handleRefresh = () => {
    getKpiData();
    if (showDeletedLoads) getDeletedSearchHistory();
    else {
      getSearchHistory();
      getTareHistory();
    }
    getPickedListTable();
  };

  const handleDeletedLoadList = () => {
    setShowDeletedLoads(!showDeletedLoads);
    setSelectedViewType(1);
  };

  return (
    <Row className="header">
      <Col className="title-details">
        <Heading5 className="d-inline title">Load History</Heading5>
        <Heading6 className="d-inline subtitle mr-2">
          {title ? ` - ${title}` : ""}
        </Heading6>
      </Col>
      <Col className="p-0">
        <Row className="refresh-content">
          {backButton}
          {isToday(range) && (
            <>
              <span className="btn-refresh">
                {!autoRefresh && (
                  <i
                    title="Refresh"
                    className="fa fa-refresh"
                    aria-hidden="true"
                    onClick={handleRefresh}
                  />
                )}
              </span>
              <span className="label">Auto refresh</span>
              <ToggleSwitch
                className="switch"
                title={
                  autoRefresh ? "Disable auto refresh" : "Enable auto refresh"
                }
                onChange={(e) => handleRefreshToggle(e)}
                checked={autoRefresh}
              />
            </>
          )}
          {isToday(range) && selectedViewType === 1 && <SubNav.Pipe />}
          {selectedViewType === 1 && !enableBulkEdit && (
            <>
              <Icon className="fa fa-trash delete-icon" />
              <span className="label">
                Deleted loads
                <span className="deleted-count">{`(${loadHistory && loadHistory.deletedHistory
                  ? loadHistory.deletedHistory.length
                  : 0
                  })`}</span>
              </span>
              <ToggleSwitch
                className="switch ml-1 mr-3"
                title={
                  showDeletedLoads
                    ? "Show Deleted Loads"
                    : "Close Deleted Loads"
                }
                onChange={handleDeletedLoadList}
                checked={showDeletedLoads}
              />
            </>
          )}
          {loadList && loadList.length > 0 ? (
            <Dropdown className="loadHistory_download">
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                <i className="fa fa-cloud-download" /> Download
              </Dropdown.Toggle>
              <Dropdown.Menu disabled={loadList.length === 0}>
                <Dropdown.Item
                  href="#"
                  className="p-0"
                  disabled={loadList.length === 0}
                >
                  <Workbook
                    filename={fileName}
                    element={
                      <Button size="sm" className="mr-2 w-100">
                        All
                      </Button>
                    }
                  >
                    {getWorkSheets("all")}
                  </Workbook>
                </Dropdown.Item>
                <Dropdown.Item href="#" className="p-0">
                  <Workbook
                    filename={fileName}
                    element={
                      <Button
                        size="sm"
                        disabled={loadList.length === 0}
                        className="mr-2 w-100"
                      >
                        Selected
                      </Button>
                    }
                  >
                    {getWorkSheets("visible")}
                  </Workbook>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : null}
          {closeButton}
        </Row>
      </Col>
    </Row>
  );
};

export default LoadHistoryHeader;
